const userRoles = {
    admin: 'admin',
    user: 'user'
};

export default userRoles